import { defineStore } from 'pinia';
import {getData, getDataContent,} from '@/services/axios-service';
import {IPartnerData, PartnerState} from "@/interfaces/partner/partner.interface";
import {BASE_URL} from "@/utils/constants/api-constants";
import {IGeneralPartnerResponse} from "@/interfaces/general-response.interface";


const INITIAL_STATE: PartnerState = {
  partnerSlug: null,
  partnerData: null,
  partnerContent: null,
  loading: false,
};


export const usePartnerStore = defineStore({
  id: 'partner',
  state: (): PartnerState => ({
    ...INITIAL_STATE,
  }),
  getters: {},
  actions: {
    async getPartnerInfoBySlug(slug: string) {
      this.loading = true;
      try {
        const res = await getData<IPartnerData>(`${BASE_URL.ORGANIZATIONS}organizations/${slug}/public`);
        const { success, data, error } = res;
        if (success && data) {
          this.loading = false;
          this.partnerData = data;
          return res.data;
        } else {
          this.loading = false;
          new Error(error);
        }
      } catch (error) {
        if (error instanceof Error) throw error;
        throw new Error(error?.toString() ?? 'Unknown error!');
      }
    },
    async getUrlContent(url: string) {
      this.loading = true;
      try {
        const res = await getDataContent<IGeneralPartnerResponse>('https://st-api-webflow.lodgerin.com/pages?url=' + url);
        if (res) {
          this.partnerContent = res.data?.data ?? null;
          this.loading = false;
          return res.data;
        } else {
          this.loading = false;
          new Error('Error fetching partner content');
        }
      } catch (error) {
        if (error instanceof Error) throw error;
        throw new Error(error?.toString() ?? 'Unknown error!');
      }
    },
  },
  persist: {},
});

export type PartnerStore = ReturnType<typeof usePartnerStore>;
